export default "__VITE_ASSET__CqI2UUuE__"